import { useEffect, useState, useRef } from "react";
import { Formik, Form, Field, useFormik } from 'formik'
import { object, string} from 'yup';
import { ArrowRightIcon } from '@heroicons/react/24/outline'
import { Transition, Dialog } from '@headlessui/react'
import { Fragment } from 'react'

import { Label } from "./Label" // Custom label
import { useOptions, usePlanes, useCarreras, useGrados, useCuotas, useTodosPlanes, } from "./custom-hooks" // custom hooks
import TarjetasAdmin from "./AdmisionesTarjeta" // tarjetas inscripción y colegiatura


const AdminStep1 = ({handleDatosFormNuevo, handleIdSeleccionado, obtenerDatosInscripcion, Validar, IdEmp, haySolicitudSeleccionada, isShowing, parametros, setIsShowing, sede, ...props }) => {
   
    const [isColInfo, setIsColInfo] = useState(false) // para mostrar tarjeta col info variables y niveladas
    const [form, setForm] = useState(1)
    // Custom hooks
    const options = useOptions(props.url, props.headers) // Sedes
    const [planes, handlePlanes]     = usePlanes  (props.url, props.headers, 'IdSede') // Planes
    const [carreras, handleCarreras] = useCarreras(props.url, props.headers, 'IdPlan') // Carreras
    const [grados, handleGrados]     = useGrados  (props.url, props.headers, 'IdCarrera') // Grados
    const [cuotas, handleCuotas]     = useCuotas  (props.url, props.headers, 'IdGrado') // Cuotas
    const campusRef = useRef(null);
 
    const initialValues = {
        "IdSede": "",
        "IdPlan": "",
        "IdCarrera": "",
        "IdGrado": ""
    }

    const validationSchema = object({
        "IdSede":    string().required('Dato obligatorio'),
        "IdPlan":    string().required('Dato obligatorio'),
        "IdCarrera": string().required('Dato obligatorio'),
        "IdGrado":   string().required('Dato obligatorio')
    })
    // Para cuando regrese del paso 2 llenar datos con los estados
    // Prop formik 
    const formikProps = useFormik({
        initialValues,
        validationSchema
    })
    // Lllenados datos con estados

    useEffect(() => {
        if(IdEmp !== 'PPUBLIC001'){
            formikProps.initialValues.IdSede    = props.IdSede || sede // para cuando el usuario sea administrativo , aparaezca por defecto su sede
            handlePlanes(props.IdSede || sede, formikProps.setFieldValue)
        }
    }, [options])
    useEffect(() => {
        setForm(1)
        if (props.valido === 1) {
            formikProps.initialValues.IdSede    = props.IdSede
            formikProps.initialValues.IdPlan    = props.IdPlan
            formikProps.initialValues.IdCarrera = props.IdCarrera
            formikProps.initialValues.IdGrado   = props.IdGrado
            formikProps.initialValues.Email     = props.Email
            formikProps.initialValues.Dpi       = props.Dpi
            handlePlanes(props.IdSede, formikProps.setFieldValue)
            handleCarreras(props.IdPlan, formikProps.setFieldValue, props.IdSede)
            handleGrados(props.IdCarrera, formikProps.setFieldValue, props.IdSede)
            handleCuotas(props.IdGrado, formikProps.setFieldValue, props.IdSede)
            !props.IdSede ? setIsShowing(false): setIsShowing(true) // condicional para que se oculte si tiene parametros
        }
   
    }, [])
    
    // Método general para las llenar combos
    const handleLocal = async (e, setFieldValue, Idsede, opcion) => {
        
        switch (opcion) {
                case 1:
                    await handlePlanes(e.target.value, setFieldValue)
                    await handleCarreras('', setFieldValue, e.target.value)
                    await handleGrados('', setFieldValue, e.target.value)
                    setIsShowing(false)
                break;
                case 2:                    
                    handleCarreras(e.target.value, setFieldValue, Idsede)
                    handleGrados('', setFieldValue, Idsede)
                    setIsShowing(false)
                break;
                case 3:
                    handleGrados(e.target.value, setFieldValue, Idsede)
                    setIsShowing(false)
                break;
                case 4:
                    handleCuotas(e.target.value, setFieldValue, Idsede)
                    setIsShowing(true)
                break;
            default:

                break;
        }
        
        obtenerDatosInscripcion([e.target.name][0], e.target.options[e.target.selectedIndex].text, e.target.value, form)
        // Sedes: llena planes y reset carreras y grados        
    }


    // Método submit formik
    const handleSubmit = (values) => {
      
        if (!haySolicitudSeleccionada){
            handleDatosFormNuevo('', '', '', '', '', '', '', '', false)
        }
        props.paso = 1
        props.form = 2
        props.valido = 1
        props.IdSede = values.IdSede
        props.IdPlan = values.IdPlan
        props.IdCarrera = values.IdCarrera
        props.IdGrado = values.IdGrado
        props.Dpi = ((props.Dpi === null || props.Dpi === undefined) ? '' : props.Dpi)
        props.Email = ((props.Email === null || props.Email === undefined) ? '' : props.Email)
        props.Nombres = ((props.Nombres === null || props.Nombres === undefined) ? '' : props.Nombres)
        props.Apellidos = ((props.Apellidos === null || props.Apellidos === undefined) ? '' : props.Apellidos)
        props.FechaNace = ((props.FechaNace === null || props.FechaNace === undefined) ? '' : props.FechaNace)
        props.ColAnterior = ((props.ColAnterior === null || props.ColAnterior === undefined) ? '' : props.ColAnterior)
        props.Genero = ((props.Genero === null || props.Genero === undefined) ? '' : props.Genero)
        props.NombresE = ((props.NombresE === null || props.NombresE === undefined) ? '' : props.NombresE)
        props.ApellidosE = ((props.ApellidosE === null || props.ApellidosE === undefined) ? '' : props.ApellidosE)
        props.EmailE = ((props.EmailE === null || props.EmailE === undefined) ? '' : props.EmailE)
        props.Cel = ((props.Cel === null || props.Cel === undefined) ? '' : props.Cel)
        Validar(props) // Método pasado del AdmisionesIndex
    }

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values) => handleSubmit(values)}
            validationSchema={validationSchema}
        >
            {({ setFieldValue, values, resetForm, errors }) => {
                             
                return (
                    <Form>
                        <div className="bg-primarioMira px-4 py-5 shadow rounded-lg sm:p-6">
                            <div className="sm:flex sm:items-center">
                                <div className="sm:flex-auto">
                                    <h1 className="text-lg font-semibold text-white">PARA INICIAR EL PROCESO DE ADMISIÓN SELECCIONA LOS SIGUIENTES DATOS</h1>
                                    <p className="px-2 text-base font-bold text-grisMira">
                                        NOTA IMPORTANTE:
                                    </p>
                                    <p className="px-4 text-sm text-grisMira">
                                        Recuerda que la cita no se agenda de forma automática en el sistema, debes llamar a la sede correspondiente.
                                        <br></br>
                                        Los períodos de descuentos siguen corriendo, son aplicados hasta el momento de la inscripción.
                                        <br></br>
                                        El pago de la Evaluación Diagnóstica no reserva tú descuento.
                                    </p>
                                </div>
                            </div>
                            <div className="mt-2 lg:grid lg:grid-cols-6 lg:gap-6">
                                <div className="mt-2 lg:col-span-2 lg:mt-0">
                                    <div className="px-4 py-4 grid grid-cols-2 gap-6 rounded-lg bg-secundarioMira">
                                        <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                            <Label lbl="Selecciona el campus al que deseas inscribirte" field="IdSede" />
                                            <Field
                                                ref={campusRef}
                                                onChange={(e) => handleLocal(e, setFieldValue, '', 1)}
                                                name='IdSede' as='select' className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                                                <option value=''>---Selecciona campus---</option>
                                                {options?.sedes?.map((sede) => <option key={sede.IdSede} value={sede.IdSede}>{sede.Sede}</option>
                                                )}
                                            </Field>
                                        </div>
                                        <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                            <Label lbl="Selecciona el plan de estudios" field="IdPlan" />
                                            <Field
                                                onChange={(e) => handleLocal(e, setFieldValue, values.IdSede, 2)}
                                                name='IdPlan' as='select' className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                                                <option value=''>---Selecciona plan---</option>
                                                {(planes?.length > 0) ?
                                                    planes?.map((plan) => <option key={plan.IdPlan} value={plan.IdPlan}>{plan.NombrePlan}</option>
                                                    ) : null}
                                            </Field>
                                        </div>
                                        <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                            <Label lbl="Selecciona la carrera a cursar" field="IdCarrera" />
                                            <Field
                                                onChange={(e) => handleLocal(e, setFieldValue, values.IdSede, 3)}
                                                name='IdCarrera' as='select' className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                                                <option value=''>---Selecciona nivel académico---</option>
                                                {(carreras?.length > 0) ?
                                                    carreras?.map((carrera) => <option key={carrera.IdCarrera} value={carrera.IdCarrera}>{carrera.Nombre}</option>
                                                    ) : null}
                                            </Field>
                                        </div>
                                        <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                            <Label lbl="Selecciona el grado" field="IdGrado" />
                                            <Field
                                                onChange={(e) => handleLocal(e, setFieldValue, values.IdSede, 4)}
                                                name='IdGrado' as='select' className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                                                <option value=''>---Selecciona grado---</option>
                                                {(grados?.length > 0) ?
                                                    grados?.map((grado) => <option key={grado.IdGrado} value={grado.IdGrado}>{grado.Nombre}</option>
                                                    ) : null}
                                            </Field>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex justify-center lg:col-start-1 lg:col-end-3 row-start-2">
                                    <p className="px-4 mt-2 text-base text-secundario">
                                        Puedes optar por más descuentos si continuas el proceso.
                                    </p>
                                <div className="flex justify-end lg:col-start-2 lg:col-end-2 row-start-2">
                                    <button
                                        type="submit"
                                        className="relative inline-flex justify-center rounded-md border border-transparent bg-azulBrillanteMira py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                                    >
                                        <div className="flex m-auto">
                                            <ArrowRightIcon className="h-5 w-5 text-white" aria-hidden="true" />
                                            <p className="ml-1">Aceptar</p>
                                        </div>
                                    </button>
                                </div>
                                </div>
                                <div
                                className={"col-span-2 block  xl:hidden"}
                                >
                                <Transition
                                    show={isShowing}
                                    enter="transform transition duration-[400ms]"
                                    enterFrom="opacity-0 rotate-[-120deg] scale-50"
                                    enterTo="opacity-100 rotate-0 scale-100 "
                                    leave="transform duration-200 transition ease-in-out"
                                    leaveFrom="opacity-100 rotate-0 scale-100 "
                                    leaveTo="opacity-0 scale-95 "
                                >
                                    <div className="lg:col-start-1 lg:col-end-1 sm:col-span-2 lg:col-span-2">
                                        <TarjetasAdmin
                                            titulo={'INSCRIPCIÓN'}
                                            subtitulo1={'Promocional'}
                                            valor={cuotas[0]?.Ins}
                                            icono={1}
                                            setIsColInfo={setIsColInfo} />
                                    </div>
                                </Transition>
                                <Transition
                                    show={isShowing}
                                    enter="transform transition duration-[400ms]"
                                    enterFrom="opacity-0 rotate-[-120deg] scale-50"
                                    enterTo="opacity-100 rotate-0 scale-100"
                                    leave="transform duration-200 transition ease-in-out"
                                    leaveFrom="opacity-100 rotate-0 scale-100"
                                    leaveTo="opacity-0 scale-95 "
                                >
                                    <div className="xl:col-start-2 xl:col-end-2 sm:col-span-2 lg:col-span-2">
                                        <TarjetasAdmin
                                            titulo={'COLEGIATURA'}
                                            subtitulo1={'La cuota que se muestra'}
                                            subtitulo2={'corresponde a la colegiatura de'}
                                            subtitulo3={'enero en modalidad variable'}
                                            valor={cuotas[0]?.Col}
                                            icono={2}
                                            setIsColInfo={setIsColInfo} />
                                    </div>
                                </Transition>
                                </div>

                                <Transition
                                    show={isShowing}
                                    enter="transform transition duration-[400ms]"
                                    enterFrom="opacity-0 rotate-[-120deg] scale-50"
                                    enterTo="opacity-100 rotate-0 scale-100 "
                                    leave="transform duration-200 transition ease-in-out"
                                    leaveFrom="opacity-100 rotate-0 scale-100 "
                                    leaveTo="opacity-0 scale-95 "
                                >
                                    <div className="lg:col-start-1 lg:col-end-1 sm:col-span-2 lg:col-span-2 hidden xl:block">
                                        <TarjetasAdmin
                                            titulo={'INSCRIPCIÓN'}
                                            subtitulo1={'Promocional'}
                                            valor={cuotas[0]?.Ins}
                                            icono={1}
                                            setIsColInfo={setIsColInfo} />
                                    </div>
                                </Transition>
                                <Transition
                                    show={isShowing}
                                    enter="transform transition duration-[400ms]"
                                    enterFrom="opacity-0 rotate-[-120deg] scale-50"
                                    enterTo="opacity-100 rotate-0 scale-100"
                                    leave="transform duration-200 transition ease-in-out"
                                    leaveFrom="opacity-100 rotate-0 scale-100"
                                    leaveTo="opacity-0 scale-95 "
                                >
                                    <div className="xl:col-start-2 xl:col-end-2 sm:col-span-2 lg:col-span-2 hidden xl:block">
                                        <TarjetasAdmin
                                            titulo={'COLEGIATURA'}
                                            subtitulo1={'La cuota que se muestra'}
                                            subtitulo2={'corresponde a la colegiatura de'}
                                            subtitulo3={'enero en modalidad variable'}
                                            valor={cuotas[0]?.Col}
                                            icono={2}
                                            setIsColInfo={setIsColInfo} />
                                    </div>
                                </Transition>

                                <Transition.Root appear show={isColInfo} as={Fragment}>
                                    <Dialog as="div" className="relative z-10" onClose={() => setIsColInfo(false)}>
                                        <Transition.Child
                                            as={Fragment}
                                            enter="ease-out duration-300"
                                            enterFrom="opacity-0"
                                            enterTo="opacity-100"
                                            leave="ease-in duration-200"
                                            leaveFrom="opacity-100"
                                            leaveTo="opacity-0"
                                        >
                                            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                                        </Transition.Child>
                                        <div className="fixed inset-0 z-10 overflow-y-auto">
                                            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                                <Transition.Child
                                                    as={Fragment}
                                                    enter="ease-out duration-300"
                                                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                                                    leave="ease-in duration-200"
                                                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                                >
                                                    <Dialog.Panel className="lg:w-[25%] lg:h-[25%] sm:h-[100%] bg-primarioMira p-6">
                                                        <TarjetasAdmin
                                                            titulo={'Modalidad variable'}
                                                            subtitulo1={'Los descuentos establecidos se aplican a ciertos meses y'}
                                                            subtitulo2={'tus colegiaturas mensuales quedarán variables.'}
                                                            setIsColInfo={setIsColInfo}
                                                            colortexto1={'indigo-500'} />
                                                        <TarjetasAdmin
                                                            titulo={'Modalidad nivelada'}
                                                            subtitulo1={'Los descuentos establecidos se distribuyen en todas'}
                                                            subtitulo2={'tus colegiaturas para que queden con el mismo valor.'}
                                                            setIsColInfo={setIsColInfo}
                                                            colortexto1={'indigo-500'} />
                                                        <div className="mt-5 sm:mt-6">
                                                            <button
                                                                type="button"
                                                                className="relative inline-flex justify-center rounded-md border border-transparent bg-azulBrillanteMira py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                                                                onClick={() => setIsColInfo(false)}
                                                            >
                                                                Regresar
                                                            </button>
                                                        </div>
                                                    </Dialog.Panel>
                                                </Transition.Child>
                                            </div>
                                        </div>
                                    </Dialog>
                                </Transition.Root>
                            </div>
                        </div>
                    </Form >
                );
            }}
        </Formik >
    )
}

export default AdminStep1